import i18n from './index';
import { useTranslation } from 'react-i18next';
import { siteTranslations } from './site-translations';
import { storyTranslations } from './story-translations';
import { sdkTranslations } from './sdk-translations';
const translations = {...siteTranslations, ...storyTranslations, ...sdkTranslations};
export function tr(korean: string): string {
  if ((i18n.resolvedLanguage || i18n.language).startsWith('ko')) return korean;
  return translations[korean] || translations[korean.replace(/\s+/g, ' ').trim()] || korean;
}
export function useSiteLanguage() { useTranslation(); }
export function siteLocale() { return (i18n.resolvedLanguage || i18n.language).startsWith('ko') ? 'ko-KR' : 'en-US'; }
